import {isAuth} from "@/assets/utils/auth.utils";
import MyCompany from "@/pages/mycompany/MyCompany.vue";
import MyCompanyProfile from "@/pages/mycompany/MyCompanyProfile.vue";
import RunningTotals from "@/pages/mycompany/RunningTotals.vue";
import MyTeamMembers from "@/pages/mycompany/MyTeamMembers.vue";
import RolesPermissions from "@/pages/mycompany/RolesPermissions.vue";
import AddRole from "@/pages/mycompany/AddRole.vue";
import ClientStatusTypes from "@/pages/mycompany/ClientStatusTypes.vue";
import AffiliatePaymentMethods from "@/pages/mycompany/AffiliatePaymentMethods.vue";
import ClientPaymentMethods from "@/pages/mycompany/ClientPaymentMethods.vue";
import AutomatedNotifications from "@/pages/mycompany/AutomatedNotifications.vue";
import LetterTemplates from "@/pages/mycompany/LetterTemplates.vue";
import AddLetterTemplate from "@/pages/mycompany/AddLetterTemplate.vue";
import ClientAgreements from "@/pages/mycompany/ClientAgreements.vue";
import DigitalSignatureRecords from "@/pages/mycompany/DigitalSignatureRecords.vue";
import DeliveryMethods from "@/pages/mycompany/DeliveryMethods.vue";

export default [
  {
    name: "my-company",
    path: "/my-company",
    component: MyCompany,
    beforeEnter: isAuth,
    redirect: "/my-company/profile",
    children: [
      {
        path: "profile",
        name: "my-company-profile",
        component: MyCompanyProfile,
        beforeEnter: isAuth,
        meta: {
          permission: "view",
          way: "my-company-profile",
        },
      },
      {
        path: "running-totals",
        name: "running-totals",
        component: RunningTotals,
        beforeEnter: isAuth,
        meta: {
          permission: "view",
          way: "running-totals",
        },
      },
      {
        path: "team-members",
        name: "team-members",
        component: MyTeamMembers,
        beforeEnter: isAuth,
        meta: {
          permission: "view",
          way: "team-members",
        },
      },
      {
        path: "roles-permissions",
        name: "roles-permissions",
        component: RolesPermissions,
        beforeEnter: isAuth,
        meta: {
          permission: "view",
          way: "roles-permissions",
        },
      },
      {
        path: "add-role",
        name: "add-role",
        component: AddRole,
        beforeEnter: isAuth,
        meta: {
          permission: "edit",
          way: "roles-permissions",
        },
      },
      {
        path: "update-role/:id",
        name: "update-role",
        component: AddRole,
        beforeEnter: isAuth,
        meta: {
          permission: "view",
          way: "roles-permissions",
        },
      },
      {
        path: "client-status-types",
        name: "client-status-types",
        component: ClientStatusTypes,
        beforeEnter: isAuth,
        meta: {
          permission: "view",
          way: "client-status-types",
        },
      },
      {
        path: "affiliate-payment-methods",
        name: "affiliate-payment-methods",
        component: AffiliatePaymentMethods,
        beforeEnter: isAuth,
        meta: {
          permission: "view",
          way: "payment-methods",
        },
      },
      {
        path: "client-payment-methods",
        name: "client-payment-methods",
        component: ClientPaymentMethods,
        beforeEnter: isAuth,
        meta: {
          permission: "view",
          way: "payment-methods",
        },
      },
      {
        path: "automated-notifications",
        name: "automated-notifications",
        component: AutomatedNotifications,
        beforeEnter: isAuth,
        meta: {
          permission: "view",
          way: "automated-notifications",
        },
      },
      // Letter templates keep the fax-templates path and permission key: the
      // key is stored in role documents.
      {
        path: "fax-templates",
        name: "fax-templates",
        component: LetterTemplates,
        beforeEnter: isAuth,
        meta: {
          permission: "view",
          way: "fax-templates",
        },
      },
      {
        path: "add-fax-template",
        name: "add-fax-template",
        component: AddLetterTemplate,
        beforeEnter: isAuth,
        meta: {
          permission: "edit",
          way: "fax-templates",
        },
      },
      {
        path: "update-fax-template/:id",
        name: "update-fax-template",
        component: AddLetterTemplate,
        beforeEnter: isAuth,
        meta: {
          permission: "edit",
          way: "fax-templates",
        },
      },
      {
        path: "client-agreements",
        name: "client-agreements",
        beforeEnter: isAuth,
        component: ClientAgreements,
        meta: {
          permission: "view",
          way: "client-agreements",
        },
      },
      {
        path: "digital-signature-records",
        name: "digital-signature-records",
        beforeEnter: isAuth,
        component: DigitalSignatureRecords,
        meta: {
          permission: "view",
          way: "client-agreements",
        },
      },
      {
        path: "delivery-methods",
        name: "delivery-methods",
        beforeEnter: isAuth,
        component: DeliveryMethods,
        meta: {
          permission: "view",
          way: "delivery-methods",
        },
      },
    ],
  },
];
